import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import AddToListButton from './components/AddToListButton/AddToListButton';
import ShareButton from './components/ShareButton/ShareButton';
import BrowserContext from '../../contexts/BrowserContext';
import ProductPageContext from '../../contexts/ProductPageContext';

export default function ListAndShareSection({
  productId = '', kic, sku, seq, store, storeId,
}) {
  const isBrowser = useContext(BrowserContext);
  const ProductPageState = useContext(ProductPageContext);
  const { tmntData, collectionData } = ProductPageState;
  const hasShareButton = Boolean(isBrowser && navigator.share);
  return (
    <div className="list-and-share-section">
      <AddToListButton
        kic={kic}
        sku={sku}
        productId={productId}
        tmntData={tmntData}
        store={store}
        storeId={storeId}
      />
      {
        hasShareButton && (
          <ShareButton
            seq={seq}
            productName={collectionData.productName}
            tmntData={tmntData}
            brandName={collectionData.brandObject.name}
            parentBrand={collectionData.brandObject.parentBrand}
          />
        )
      }
    </div>
  );
}

ListAndShareSection.propTypes = {
  productId: PropTypes.string.isRequired,
};
